import { POST } from "../../APiHelper/API";

export const transferPlayer = (id, onSuccess, onError) => {
    const data = {
        id: id,
    };
    POST(`/api/v1/leagues/player/transfer`, data, onSuccess, onError);
};
